import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import MaintenanceMode from "../pages/MaintenanceMode";

/**
 * Component that checks maintenance mode and redirects if needed
 * Admins can bypass maintenance mode
 */
export default function MaintenanceCheck({ children }) {
  const [checking, setChecking] = useState(true);
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const res = await fetch("/api/maintenance-status");
        const data = await res.json();
        
        if (data.maintenanceMode) {
          // Check if user is admin
          const token = localStorage.getItem("token");
          if (token) {
            try {
              const decoded = jwtDecode(token);
              // If user is admin, allow access
              if (decoded.role === "ADMIN") {
                setMaintenanceMode(false);
                setChecking(false);
                return;
              }
            } catch (err) {
              // Token invalid, continue to show maintenance mode
            }
          }
          
          // Maintenance mode is enabled and user is not admin
          setMaintenanceMode(true);
        } else {
          setMaintenanceMode(false);
        }
      } catch (error) {
        console.error("Error checking maintenance mode:", error);
        // On error, assume no maintenance mode (fail open)
        setMaintenanceMode(false);
      } finally {
        setChecking(false);
      }
    };

    checkMaintenance();
  }, [navigate]);

  if (checking) {
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        minHeight: "50vh" 
      }}>
        <div style={{ 
          fontFamily: "'Courier New', monospace",
          fontSize: "24px",
          fontWeight: "900"
        }}>
          LOADING...
        </div>
      </div>
    );
  }

  if (maintenanceMode) {
    return <MaintenanceMode />;
  }

  return children;
}
